import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'

interface IInitJBPPartnerDataParams {
  ownerId: string
  partnerId: string
  fYear: number

  startLoadData: () => void
  stopLoadData: () => void
}

export const initJBPPartnerData = async ({
  ownerId,
  partnerId,
  fYear,
  startLoadData,
  stopLoadData,
}: IInitJBPPartnerDataParams) => {
  startLoadData()
  const [accessToken] = await getTokens(ownerId)
  const url = proxy('/webservice/614/sp/v3/spJBPPartnerDataInit/call')
  const payload: IObjectAny = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
  }

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const response = await Rest.post({ url, payload, cancelObject: new HttpCancel(), headers })
  stopLoadData()
  if (response && response['Total'] === 1) {
    window.location.reload()
  }
}
